// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"styles__inputContainer--1vyPl","inputHeader":"styles__inputHeader--3io24","input":"styles__input--GaYrn","mandatory":"styles__mandatory--XNqUY"};